/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import { getFeatureFlags } from '../../../utils/featureSelectors';
import { isEmpty } from '../../../utils/object';

class GiftMessage extends React.PureComponent {
    render() {
        const {
            cardMessage,
            cardMsgEnable,
            openMmo,
            itemDetailList,
            orderData,
            featureFlags,
        } = this.props;
        const ENABLE_MMO =            !isEmpty(featureFlags)
            && featureFlags['is-account-mmo-enabled'] === true;
        return (
            <>
                <h2 className="gray-color">
                    <div className="split align-center">
                        <div className="align-left">Gift Message</div>
                        {cardMsgEnable === 'true' && ENABLE_MMO ? (
                            <Button
                                className="buttonBlue flex-none min-width-100"
                                onClick={() => openMmo(
                                    'editMsg',
                                    itemDetailList,
                                    orderData,
                                )}
                            >
                                Modify
                            </Button>
                        ) : (
                            ''
                        )}
                    </div>
                </h2>
                <div>{cardMessage || 'No Card Message'}</div>
            </>
        );
    }
}

GiftMessage.defaultProps = {
    cardMessage: null,
    cardMsgEnable: null,
    featureFlags: {},
};

GiftMessage.propTypes = {
    cardMessage: PropTypes.string,
    cardMsgEnable: PropTypes.string,
    openMmo: PropTypes.func.isRequired,
    orderData: PropTypes.object.isRequired,
    featureFlags: PropTypes.object,
    itemDetailList: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) {}
    }
    return {
        featureFlags,
    };
};

export default connect(
    mapStateToProps,
    null,
)(GiftMessage);
